module.exports = __webpack_public_path__ + "static/media/ic_draft_hover.824d4f37.svg";